import * as React from "react";
import { useNavigate } from "react-router-dom";
import { AppLayout, SettingsNav, MFASettings } from "@bi-studio/shared/components";
import { useAuth } from "@bi-studio/shared/hooks";
import { Container, Stack, Title, Text } from "@mantine/core";
import { AiAssistant } from "@/components/ai";

export default function SettingsMfaPage() {
    const { isAuthenticated, isLoading } = useAuth();
    const navigate = useNavigate();

    const handleLogout = React.useCallback(() => {
        navigate("/login");
    }, [navigate]);

    React.useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            navigate("/login");
        }
    }, [isAuthenticated, isLoading, navigate]);

    if (!isAuthenticated && !isLoading) {
        return null;
    }

    const sidebarContent = <SettingsNav />;

    return (
        <AppLayout
            showSidebar
            sidebarContent={sidebarContent}
            onLogout={handleLogout}
            title="Settings"
            subtitle="MFA Configuration"
            floatingContent={<AiAssistant />}
        >
            <Container size="xl" p={0}>
                <Stack gap="xl">
                    <div>
                        <Title order={2} fw={700}>Security Settings</Title>
                        <Text c="dimmed">Manage your account security and authentication methods.</Text>
                    </div>

                    <div className="max-w-2xl">
                        <MFASettings hideAdminMfa={true} />
                    </div>
                </Stack>
            </Container>
        </AppLayout>
    );
}
